import React from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Calendar,
  FileText,
  CheckCircle,
  Trash2,
  Reply,
} from "lucide-react";

const UserCommentCard = ({
  comment,
  formatDate,
  handleCheck,
  confirmDelete,
  isDeleting,
  CheckRole,
  handleReply,
  DestinationPage,
}) => {
  const navigate = useNavigate();

  const navigateToBlogDetail = (blogId) => {
    navigate(`/blog/detail/${blogId}`);
  };

  return (
    <div
      className="card border-0 shadow-sm"
      style={{
        borderRadius: "12px",
        transition: "transform 0.2s, box-shadow 0.2s",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
      }}
    >
      {/* Header */}
      <div
        className="card-header border-0"
        style={{ backgroundColor: "#053251", padding: "1rem 1.5rem" }}
      >
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <User size={18} color="#7cc890" />
            <span style={{ color: "#fff", fontWeight: "500" }}>
              {comment.fullName}
            </span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Calendar size={16} color="#7cc890" />
            <span style={{ color: "#e9ecef", fontSize: "0.9rem" }}>
              {formatDate(comment.date)}
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="card-body" style={{ padding: "1.5rem" }}>
        <div className="mb-3">
          <div className="d-flex align-items-center gap-2 mb-2">
            <FileText size={18} color="#053251" />
            <strong className="iran-sans" style={{ color: "#053251" }}>
              مقاله:
            </strong>
            <span
              style={{ color: "#062641ff", cursor: "pointer" }}
              onClick={() => navigateToBlogDetail(comment.blogId)}
            >
              {comment.blogTitle}
            </span>
          </div>
        </div>

        <div
          className="p-3 mb-3 iran-sans"
          style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
        >
          <p
            className="m-0 fs-14"
            style={{
              color: "#212529",
              lineHeight: "1.8",
              textAlign: "right",
              direction: "rtl",
            }}
          >
            {comment.content}
          </p>
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            {comment.checked ? (
              <p
                className="iran-sans pt-2 m-0 me-1 fw-light"
                style={{ color: "#7cc890", fontSize: "0.8rem" }}
              >
                منتشر شده
              </p>
            ) : (
              <p
                className="iran-sans pt-2 m-0 me-1 fw-light"
                style={{ color: "#ffc107", fontSize: "0.8rem" }}
              >
                در صف انتشار
              </p>
            )}
          </div>

          <div className="d-flex gap-2">
            {CheckRole(["Admin", "Doctor", "Secretary"]) &&
              DestinationPage === "UnCheckComments" && (
                <>
                  <button
                    className="btn d-flex align-items-center gap-1"
                    style={{
                      backgroundColor: "#7cc890",
                      color: "#fff",
                      border: "none",
                      padding: "0.5rem 1.25rem",
                      borderRadius: "8px",
                      fontWeight: "500",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#6ab57d")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "#7cc890")
                    }
                    onClick={() => handleCheck(comment.id)}
                  >
                    <CheckCircle size={18} />
                    <p className="m-0 p-0 iran-sans fs-14">تایید کامنت</p>
                  </button>

                  <button
                    className="btn d-flex align-items-center gap-1"
                    style={{
                      backgroundColor: "#c4cd47ff",
                      color: "#fff",
                      border: "none",
                      padding: "0.5rem 1.25rem",
                      borderRadius: "8px",
                      fontWeight: "500",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#b6bf3fff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c4cd47ff")
                    }
                    onClick={() => handleReply(comment.id)}
                  >
                    <Reply size={18} />
                    <p className="m-0 p-0 iran-sans fs-14">پاسخ</p>
                  </button>
                </>
              )}

            <button
              className="btn d-flex align-items-center gap-1"
              style={{
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                padding: "0.5rem 1.25rem",
                borderRadius: "8px",
                fontWeight: "500",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#c82333")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#dc3545")
              }
              onClick={() => confirmDelete(comment.id)}
              disabled={isDeleting}
            >
              <Trash2 size={18} />
              <p className="m-0 p-0 iran-sans fs-14">حذف</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCommentCard;
